import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ParamMenu, Parametro } from './parametros-busqueda.model';
import { FiltroFechaComponent } from '../filtro-fecha/filtro-fecha.component';
import { IconComponent } from '../icon/icon.component';
import { ButtonComponent } from '../btn/button.component';
import { Subject, catchError, debounceTime, distinctUntilChanged, Observable, of, switchMap, tap, takeUntil } from 'rxjs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ParametrosV2 } from '@core/models/parametros/parametros';
import { DeviceService } from '@core/services/device.service';

@Component({
  selector: 'esp-opciones-busqueda',
  standalone:true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    CdkMenuModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    FiltroFechaComponent,
    IconComponent,
    ButtonComponent,
  ],
  templateUrl: './opciones-busqueda.component.html',
  styleUrls: ['./opciones-busqueda.component.scss']
})
export class OpcionesBusquedaComponent implements OnInit, OnDestroy{

  private readonly API_URL = environment.API_URL;

  
  restartFilterDate: boolean = false;
  //Show Opciones----------------------------------------------------------------------------------------------------------------
  @Input()
  showDateFilter = false;

  @Input()
  labelDateFilter = "";

  @Input()
  showSearch = false;

  @Input()
  showFirstDisplayFilter = false;

  @Input()
  showSecondDisplayFilter = false;

  @Input()
  showThirdDisplayFilter = false;

  @Input()
  showButton = false;

  //Filtro de Fecha----------------------------------------------------------------------------------------------------------------
  @Input()
  filterDateAppearance: number = 1; // 1: DateFilter - 2: DateFilterWithCeros - 3: DateFilterWithoutCeros - 4: DateFilterUSDate
  
  @Input()
  setFilterDateSelectionBg!: string;

  @Input()
  setFilterDateButtonBg!: string;

  @Input()
  setFilterDateOptionSelected!: string;

  @Input()
  setFilterDateTextColour!: string;

  @Input()
  setDateSelectedDefault!: number;

  @Output()
  sendDateFilter = new EventEmitter<any>();
  
  @Output()
  sendDateFilterWithCeros = new EventEmitter<any>();

  @Output()
  sendDateFilterWithoutCeros = new EventEmitter<any>();

  @Output()
  sendDateFilterUSDate = new EventEmitter<any>();

  //Filtro de Búsqueda-------------------------------------------------------------------------------------------------------------
  @Input()
  searchInputPlaceHolder: string = 'Buscar';

  @Input()
  searchInputAdjustWidth: boolean = false;

  @Output()
  searchInputValue = new EventEmitter<any>();

  //Primer Filtro Desplazable-------------------------------------------------------------------------------------------------------------
  @Input()
  firstDisplayFilterPlaceholder: {
    indicador: boolean, // Indica si es "True": Seleccionable o "False": No Seleccionable
    placeholder: string // Nombre de la opción
  } = {indicador: false, placeholder: 'Opciones'};

  @Input()
  firstDisplayFilterData: ParametrosV2[] = [];

  @Output()
  firstDisplayFilterSendValue = new EventEmitter<any>();

  @Input()
  firstDisplaySelectedValue: boolean = true;

  //Segundo Filtro Desplazable-------------------------------------------------------------------------------------------------------------
  @Input()
  secDisplayFilterPlaceholder: {
    indicador: boolean, // Indica si es "True": Seleccionable o "False": No Seleccionable
    placeholder: string // Nombre de la opción
  } = {indicador: false, placeholder: 'Opciones'};

  @Input()
  secDisplayFilterData: ParametrosV2[] = [];

  @Output()
  secDisplayFilterSendValue = new EventEmitter<any>();

   //Segundo Filtro Desplazable-------------------------------------------------------------------------------------------------------------
   @Input()
   thirdDisplayFilterPlaceholder: {
     indicador: boolean, // Indica si es "True": Seleccionable o "False": No Seleccionable
     placeholder: string // Nombre de la opción
   } = {indicador: false, placeholder: 'Opciones'};
 
   @Input()
   thirdDisplayFilterData: ParametrosV2[] = [];
 
   @Output()
   thirdDisplayFilterSendValue = new EventEmitter<any>();
 

  //Botón ejecutable-------------------------------------------------------------------------------------------------------------------------
  @Input()
  buttonBg: string = '';

  @Input()
  buttonText: string = 'Añadir';

  @Output()
  buttonAccion = new EventEmitter<any>();

  // Menú Desplegable-------------------------------------------------------------------------------------------------------------------------
  @Input()
  menuOpt: ParamMenu[] = [];

  @Input()
  firstMenuOpt: boolean = true;

  @Output()
  primerActionMenu = new EventEmitter<any>();

  @Output()
  segundoActionMenu = new EventEmitter<any>();

  @Output()
  tercerActionMenu = new EventEmitter<any>();

  //Buscador con autocompletado
  @Input() showDynamicSearch: boolean = false; // Mostrar u ocultar el buscador dinámico
  @Input() searchUrl?: string; // URL para la búsqueda
  @Input() searchInputAutocompletePlaceHolder: string = 'Buscar'; // Placeholder del buscador
  selectedItem: any = null; // Variable para almacenar el ítem seleccionado
  private readonly destroy$ = new Subject<void>();


  @Output() searchSelect = new EventEmitter<any>(); // Emitir selección

  searchControl = new FormControl(''); // Control para el buscador
  searchResults: any[] = []; // Resultados de la búsqueda

  //Variables del componente-------------------------------------------------------------------------------------------------------------
  form:FormGroup = this.fb.group({
    frmSearchDate:new FormControl(""),
    frmSearch:new FormControl("")
  });
  @ViewChild('preSelected') nameInput!: ElementRef;

  //MOBILE
  isMobile!: Boolean;
  
  public get searchForm(){
    return this.form.get("frmSearch");
  }

  constructor(
    private fb:FormBuilder, 
    private http: HttpClient,
    private deviceService: DeviceService
  ) {
  }

  ngOnInit(): void {
    this.deviceService.isMobile$.pipe(takeUntil(this.destroy$)).subscribe((isMob) => {
      this.isMobile = isMob;
    });

    if(this.buttonBg != undefined){
      document.documentElement.style.setProperty('--color-boton',this.buttonBg);
    }

    if (this.showDynamicSearch) {
      this.loadInitialSearch(false).pipe(takeUntil(this.destroy$)).subscribe(); // Cargar resultados iniciales al iniciar
      this.setupDynamicSearch(); // Configurar el buscador si está habilitado
    }

    this.onFilter();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(){
    if (this.nameInput) {
      this.nameInput.nativeElement.focus();
    }
  }


  //FILTRO DINAMICO
  private setupDynamicSearch(): void {
    this.searchControl.valueChanges
      .pipe(
        debounceTime(300), // Espera 300ms para reducir solicitudes
        distinctUntilChanged(),
        takeUntil(this.destroy$),
        switchMap((query) => {
          // Si el valor es un objeto, no realizar búsqueda
          if (typeof query === 'object' || !this.searchUrl) {
            this.searchResults = []; // Limpia resultados en caso de objeto
            return of([]); // No realizar solicitudes con objetos
          }
  
          // Si no hay consulta, cargar resultados iniciales
          if (!query) {
            return this.loadInitialSearch(false);
          }
  
          // Realizar búsqueda con el valor ingresado
          const body = { query }; // Estructura del cuerpo para la solicitud POST
          return this.http.post<any[]>(this.API_URL + "/" + this.searchUrl, body).pipe(
            catchError((err) => {
              console.error('Error en la búsqueda:', err);
              return of([]); // Manejo de errores, devuelve vacío
            })
          );
        })
      )
      .subscribe((results: any) => {
        this.searchResults = results.data || []; // Asignar los resultados
      });
  }
  

    /**
     * Realizar una búsqueda inicial o mantener los resultados actuales
     * @param emitEvent Indica si se debe emitir un evento tras cargar los resultados
     */
    private loadInitialSearch(emitEvent = true): Observable<any[]> {
      if (!this.searchUrl) {
        console.warn('URL para búsqueda no está definida');
        return of([]);
      }

      const body = { query: '' }; // Búsqueda inicial sin filtro
      return this.http.post<any[]>(this.API_URL + "/" + this.searchUrl, body).pipe(
        tap((results: any) => {
          this.searchResults = results.data || [];
          if (emitEvent) {
            this.searchSelect.emit(null); // Emitir evento si es necesario
          }
        }),
        catchError((err) => {
          console.error('Error en la búsqueda inicial:', err);
          this.searchResults = [];
          return of([]);
        })
      );
    }

    /**
     * Maneja la selección de un elemento
     */
    selectSearchItem(item: any): void {
      const displayValue = item?.name || item.nombre ||  item?.descripcion || item?.valor || 'Elemento';
      this.searchControl.setValue(displayValue, { emitEvent: false }); // Establece el texto del elemento seleccionado
      this.selectedItem = item;
      this.searchSelect.emit(item); // Emitir selección
    }

    /**
     * Resetear el buscador y mantener resultados iniciales
     */
    resetSearch(): void {
      this.selectedItem = null;
      this.searchControl.setValue('', { emitEvent: false }); // Limpiar el valor del input
      this.loadInitialSearch(false).pipe(takeUntil(this.destroy$)).subscribe(); // Mantener resultados iniciales sin emitir evento
      this.searchSelect.emit(); // Emitir selección
    }


  setDateFilter(value: any){
    if (this.filterDateAppearance == 1) {
      this.form.get('frmSearchDate')?.setValue(value);
      this.sendDateFilter.emit(value);
    }
  }
  
  setDateFilterWithCeros(value: any){
    if (this.filterDateAppearance == 2) {
    this.form.get('frmSearchDate')?.setValue(value);
    this.sendDateFilterWithCeros.emit(value);
  }
  }
  
  setDateFilterWithoutCeros(value: any){
    if (this.filterDateAppearance == 3) {
    this.form.get('frmSearchDate')?.setValue(value);
    this.sendDateFilterUSDate.emit(value);
  }
  }
  
  setDateFilterUSDate(value: any){
    if (this.filterDateAppearance == 4) {
    this.form.get('frmSearchDate')?.setValue(value);
    this.sendDateFilterUSDate.emit(value);
  }
  }
  onFilter(){
    this.searchForm?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(
      (value) => {
        this.searchInputValue.emit(String(value ?? ''))
      }
    )
  }
  changeFirstFilter(value: any){
    this.firstDisplayFilterSendValue.emit(value);
  }
  changeSecondFilter(value: any){
    this.secDisplayFilterSendValue.emit(value);
  }
  changeThirdFilter(value: any){
    this.thirdDisplayFilterSendValue.emit(value);
  }

  clearDate(event: MouseEvent) {
    
    event.stopPropagation(); // Detiene la propagación del evento de clic
    this.restartFilterDate = true;


    setTimeout(() => {
    this.restartFilterDate = false;
       // Fecha en 1900
    const startDate = new Date(1900, 0, 1); // 01/01/1900
    const startDay = ('0' + startDate.getDate()).slice(-2);
    const startMonth = ('0' + (startDate.getMonth() + 1)).slice(-2);
    const startYear = startDate.getFullYear();
    const formattedStartDate = `${startDay}/${startMonth}/${startYear}`;

    // Fecha actual
    const endDate = new Date();
    const endDay = ('0' + endDate.getDate()).slice(-2);
    const endMonth = ('0' + (endDate.getMonth() + 1)).slice(-2);
    const endYear = endDate.getFullYear();
    const formattedEndDate = `${endDay}/${endMonth}/${endYear}`;

    // Rango de fechas en formato dd/mm/yyyy - dd/mm/yyyy
    const dateRange = `${formattedStartDate} - ${formattedEndDate}`;

    // Establece el valor en el formulario y emite los eventos con el rango de fechas
   // this.setDateSelectedDefault = -1;
    this.form.get('frmSearchDate')?.setValue("");
    this.sendDateFilter.emit(dateRange);
    this.sendDateFilterWithCeros.emit(dateRange);
    this.sendDateFilterWithoutCeros.emit(dateRange);
    this.sendDateFilterUSDate.emit(dateRange);
    });

   
}

clearSearch() {
  this.form.get('frmSearch')?.setValue('');
}


}
